// The theme a person picked, kept in this browser. "system" follows the device.
// Each app's index.html reads THEME_KEY before first paint, so keep them in step.
export type ThemeChoice = "system" | "light" | "dark";
export const THEME_CHOICES: ReadonlyArray<ThemeChoice> = ["system", "light", "dark"];
export const THEME_KEY = "wh-theme";

export function storedTheme(): ThemeChoice {
  try {
    const saved = localStorage.getItem(THEME_KEY);
    return THEME_CHOICES.find((choice) => choice === saved) ?? "system";
  } catch {
    return "system";
  }
}

/** Sets the page's theme and remembers it. The tokens read `data-theme` on the root. */
export function chooseTheme(choice: ThemeChoice): void {
  const root = document.documentElement;
  switch (choice) {
    case "system": delete root.dataset.theme; break;
    case "light": case "dark": root.dataset.theme = choice; break;
    default: choice satisfies never;
  }
  try {
    if (choice === "system") localStorage.removeItem(THEME_KEY);
    else localStorage.setItem(THEME_KEY, choice);
  } catch {
    // Storage is blocked: the choice lasts for this visit.
  }
}
